import { Controller } from "@hotwired/stimulus"
import Dropzone from "dropzone"
import { DirectUpload } from "@rails/activestorage"
import { resolveDirectUploadUrl } from "../direct_upload_url"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    maxFiles: Number,
    maxFilesSize: Number,
  }

  messageWording() {
    let desc = "a file";
    if (this.maxFilesValue > 1) { desc = "files" }
    return(
      `Click here to select ${desc}. You can also drag & drop ${desc}.`
    )
  };

  connect() {
    Dropzone.autoDiscover = false
    this.inputTarget.disabled = true
    this.inputTarget.style.display = "none"
    this.pendingUploads = 0
    this.form = this.element.closest("form")
    if (this.form) {
      this.boundSubmit = this.preventSubmitWhileUploading.bind(this)
      this.form.addEventListener("submit", this.boundSubmit)
    }

    const dropzone = new Dropzone(this.element, {
      url: '/',
      maxFiles: this.maxFilesValue,
      maxFilesize: this.maxFilesSize,
      autoQueue: false,
      dictDefaultMessage: this.messageWording()
    });

    dropzone.on("addedfile", file => {
      this.pendingUploads += 1
      setTimeout(() => {
        if (file.accepted) {
          const upload = new DirectUpload(file, this.url, this)
          upload.create((error, blob) => {
            this.pendingUploads = Math.max(0, this.pendingUploads - 1)
            if (error) {
              const message = (error && error.message) || 'Photo upload failed.'
              dropzone.emit("error", file, message)
              dropzone.emit("complete", file)
              return
            }
            this.hiddenInput = document.createElement("input")
            this.hiddenInput.type = "hidden"
            this.hiddenInput.name = this.inputTarget.name
            this.hiddenInput.value = blob.signed_id
            this.inputTarget.parentNode.insertBefore(this.hiddenInput, this.inputTarget.nextSibling)
            dropzone.emit("success", file)
            dropzone.emit("complete", file)
          });
        } else {
          this.pendingUploads = Math.max(0, this.pendingUploads - 1)
        }
      }, 500)
    });
  }

  disconnect() {
    if (this.form && this.boundSubmit) {
      this.form.removeEventListener("submit", this.boundSubmit)
    }
  }

  preventSubmitWhileUploading(event) {
    if (this.pendingUploads > 0) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress",
      event => this.directUploadDidProgress(event))
  };

  directUploadDidProgress(event) {
    const percentageMeter = this.inputTarget.closest('.dropzone').querySelector('.dz-progress .dz-upload');
    if (percentageMeter) {
      let percentageComplete = ((event.loaded / event.total) * 100) + '%';

      percentageMeter.style.width = percentageComplete
    }
  }

  get url() {
    return resolveDirectUploadUrl(
      this.inputTarget.getAttribute('data-direct-upload-url')
    )
  }
}
